module.exports = __webpack_public_path__ + "img/Smartphone.5603a7d1.svg";